<script>
export default {
  name: "CardText",
  props: ["cardtext", "selected"],
  render: function(r) {
    let total = [];
    let text = this.cardtext || "";
    var nestedElement = {
      ["<i>"]: {
        limiter: "</i>",
        factory: childs => r("i", { class: "italic" }, childs)
      }
    };
    var topLevelElements = {
      ["<br>"]: () => r("br"),
      ["<br/>>"]: () => r("br")
    };
    var i = -1;
    let subs = this.$props.selected || [];
    let elements = text
      .replace(/{\d}/g, () =>
        subs[++i] != null ? subs[i][1].replace(/\.$/, "") : "____"
      )
      .split(/(<.*?>)/g)
      .filter(x => x);

    elements.forEach((x, j) => {
      if (nestedElement[x]) {
        let children = elements.splice(
          j,
          elements.indexOf(nestedElement[x].limiter) - j + 1
        );
        children.splice(-1, 1);
        children.splice(0, 1);
        total.push(nestedElement[x].factory(children));
        elements.splice(j, 0, nestedElement[x].factory(children));
      } else {
        if (topLevelElements[x]) {
          total.push(topLevelElements[x]());
        } else {
          total.push(x);
        }
      }
    });

    return r("p", {}, [total]);
  }
  //Cardtext is startnode
};

//Check for <i> <i/>

//Check for <br>
</script>